/**
 * AW RM Stat tile count-up animation.
 *
 * Finds every .aw-rm-stat__value on the page and animates its number from 0
 * to data-stat-target when it enters the viewport (30% visible). Wraps with
 * data-stat-prefix and data-stat-suffix. Only runs once per element.
 * Respects prefers-reduced-motion by skipping the animation and rendering
 * the final value immediately.
 */
(function () {
	'use strict';

	function init() {
		var nodes = document.querySelectorAll('.aw-rm-stat__value[data-stat-target]');
		if (!nodes.length) {
			return;
		}

		var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		function formatNumber(value, isInteger) {
			// Localized thousands separators, integer-only when the target is whole.
			if (isInteger) {
				return Math.round(value).toLocaleString();
			}
			return value.toFixed(1);
		}

		function render(node, value, isInteger) {
			var prefix = node.getAttribute('data-stat-prefix') || '';
			var suffix = node.getAttribute('data-stat-suffix') || '';
			node.textContent = prefix + formatNumber(value, isInteger) + suffix;
		}

		function animate(node) {
			var target = parseFloat(node.getAttribute('data-stat-target')) || 0;
			var duration = parseInt(node.getAttribute('data-stat-duration'), 10) || 1500;
			var isInteger = target === Math.floor(target);

			if (prefersReducedMotion || duration <= 0) {
				render(node, target, isInteger);
				return;
			}

			var start = null;
			function step(timestamp) {
				if (start === null) {
					start = timestamp;
				}
				var elapsed = timestamp - start;
				var progress = Math.min(elapsed / duration, 1);
				// easeOutQuad for a gentle decel at the end.
				var eased = 1 - (1 - progress) * (1 - progress);
				render(node, target * eased, isInteger);
				if (progress < 1) {
					window.requestAnimationFrame(step);
				} else {
					render(node, target, isInteger);
				}
			}
			window.requestAnimationFrame(step);
		}

		// Reset all targets to 0 so they don't briefly show the SSR'd final
		// value before the animation runs. SSR value remains in place for
		// no-JS / no-IntersectionObserver fallbacks.
		Array.prototype.forEach.call(nodes, function (node) {
			var target = parseFloat(node.getAttribute('data-stat-target')) || 0;
			var isInteger = target === Math.floor(target);
			render(node, 0, isInteger);
		});

		if (!('IntersectionObserver' in window)) {
			// Fallback: animate everything on load.
			Array.prototype.forEach.call(nodes, animate);
			return;
		}

		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					animate(entry.target);
					observer.unobserve(entry.target);
				}
			});
		}, { threshold: 0.3 });

		Array.prototype.forEach.call(nodes, function (node) {
			observer.observe(node);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
